import { useTranslation } from 'react-i18next';
import * as S from './CheckHeadset.styles';

export const CheckHeadset: React.FC = () => {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col rounded-lg bg-white p-8">
      <div className="font-semibold text-sm">
        <p>{t('page.mockTest.headsetCheck.title')}</p>
        <p>{t('page.mockTest.headsetCheck.headsetCheckDescription')}</p>
        <p>{t('page.mockTest.headsetCheck.instruction1')}</p>
        <p>{t('page.mockTest.headsetCheck.instruction2')}</p>
        <p>{t('page.mockTest.headsetCheck.instruction3')}</p>
      </div>
      <S.Audio>
        <audio controls className="w-full" autoPlay={false}>
          <source
            src="https://storage.googleapis.com/pte-magic-question-2018/audio_intro_mock_test_1691121202670.mp3"
            type="audio/mpeg"
          />
          Your browser does not support the audio element.
        </audio>
      </S.Audio>
      <div className="font-semibold text-sm">
        <p>{t('page.mockTest.headsetCheck.note1')}</p>
        <p>{t('page.mockTest.headsetCheck.note2')}</p>
      </div>
    </div>
  );
};
